import { createContext } from "react"
const UserContext = createContext({
    user: null, 
    setUser: null,
    createNotification: null
});
export default UserContext;
